









































import {
  computed,
  defineComponent,
  PropType,
  ref,
  watch,
  vue3Model
} from '~/utils/nuxt3-migration'
import { ButtonVariant } from '~/models/app/button'
import { CIcon } from '~/icons/types'

type ButtonGroupValue = string | number | boolean

interface ButtonGroupOption {
  label: string
  value: ButtonGroupValue
  variant: ButtonVariant
  icon?: CIcon
  // TODO: these are legacy props, remove them in the future
  text?: string
  name?: string
}

export default defineComponent({
  model: vue3Model,
  props: {
    options: {
      type: Array as PropType<ButtonGroupOption[]>,
      default: () => []
    },
    modelValue: {
      type: [Number, String, Boolean],
      default: null
    },
    size: {
      type: String as PropType<'xs' | 'sm' | 'md' | 'lg'>,
      default: 'md'
    },
    variant: {
      type: String,
      default: 'secondary'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    truncate: {
      type: Boolean,
      default: true
    },
    containerClasses: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const selected = ref(props.modelValue)

    watch(
      () => props.modelValue,
      (newValue: ButtonGroupValue) => {
        selected.value = newValue
      }
    )

    function changeSelectedValue(value: ButtonGroupValue) {
      if (selected.value !== value) {
        selected.value = value

        emit('update:modelValue', value)
      }
    }

    const roundnessClass = computed(() => {
      switch (props.size) {
        case 'xs':
          return 'tw-rounded-md'
        case 'sm':
          return 'tw-rounded-lg'
        case 'lg':
          return 'tw-rounded-2xl'
        case 'md':
        default:
          return 'tw-rounded-xl'
      }
    })

    return {
      selected,
      roundnessClass,
      changeSelectedValue
    }
  }
})
